<template>
    <div class="target-time-count-down">
        <div
            class="clock-image-container"
            :style="containerStyle"
        >
            <div
                class="original-time"
                :style="textStyle"
            >
                {{ formatSeconds(originalTime) }}
            </div>
            <div
                class="ideal-minutes"
                :style="textStyle"
            >
                {{ formatSeconds(remainingSeconds) }}
            </div>
        </div>
        <div class="buttons">
            <ui5-button
                :disabled="loading || pausingOrRestarting"
                class="finish-count-down"
                v-if="!timer.paused"
                @click="onPause()"
            >
                <spinner v-if="pausingOrRestarting" />
                {{ trans('pages.workpost_scan_product.pause') }}
            </ui5-button>
            <ui5-button
                :disabled="loading || pausingOrRestarting"
                class="finish-count-down"
                v-if="timer.paused"
                @click="onUnpause()"
            >
                <spinner v-if="pausingOrRestarting" />
                {{ trans('pages.workpost_scan_product.resume') }}
            </ui5-button>
            <ui5-button
                :disabled="loading || pausingOrRestarting"
                class="finish-count-down"
                v-if="canReportError"
                @click="onErrorReporting()"
            >
                <spinner v-if="pausingOrRestarting" />
                {{ trans('pages.workpost_scan_product.error_report') }}
            </ui5-button>
            <ui5-button
                :disabled="loading || pausingOrRestarting || !allFinished"
                class="finish-count-down"
                v-if="!timer.finished"
                @click="onFinish()"
            >
                <spinner v-if="saving" />
                {{ checkColliCount ? trans('pages.workpost_scan_product.check_colli_count') : trans('pages.workpost_scan_product.finish') }}
            </ui5-button>
        </div>
    </div>
</template>
<script>
import Spinner from '../loader/Spinner';
import localizationMixin from '../../mixins/localization';
import { callbackInterval } from '../../helpers/IntervalHelper';

export default {
    components: { Spinner },
    mixins: [localizationMixin],
    props: {
        timer: {
            required: true,
            type: Object,
        },
        loading: {
            required: true,
            type: Boolean,
        },
        allFinished: {
            required: false,
            type: Boolean,
            default: true,
        },
        pausingOrRestarting: {
            required: false,
            type: Boolean,
            default: false,
        },
        saving: {
            required: false,
            type: Boolean,
            default: false,
        },
        canReportError: {
            required: false,
            type: Boolean,
            default: false,
        },
        checkColliCount: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dummy: 0,
            originalSeconds: 0,
            originalTimeStamp: null,
            originalTime: 0,
            colors: {
                green: {
                    backColor: '#8bc34a',
                    frontColor: 'black',
                },
                orange: {
                    backColor: '#ff9100',
                    frontColor: 'black',
                },
                red: {
                    backColor: '#b2102f',
                    frontColor: 'white',
                },
            },
        };
    },
    created() {
        this.start();
    },
    watch: {
        timer() {
            this.start();
        },
    },
    methods: {
        start() {
            this.dummy = 0;
            this.originalTime = this.timer.minutes * 60;
            this.originalSeconds =
                this.originalTime - this.timer.previousSeconds;
            this.originalTimeStamp = parseInt(Date.now() / 1000, 10);

            this.$nextTick(() => {
                callbackInterval(1000, () => {
                    if (!this.timer.finished && !this.timer.paused) {
                        this.dummy++;
                        return this._isDestroyed;
                    } else {
                        return true;
                    }
                });
            });
        },
        formatSeconds(seconds) {
            const positive = Math.abs(seconds);
            return (
                (seconds < 0 ? '-' : '') +
                pad(Math.floor(positive / 60)) +
                ':' +
                pad(Math.floor(positive % 60))
            );

            function pad(value) {
                return Math.abs(value).toString().padStart(2, '0');
            }
        },
        onPause() {
            this.timer.paused = true;
            this.$emit('pause');
        },
        onUnpause() {
            this.timer.paused = false;
            this.$emit('unpause');
        },
        onFinish() {
            if (this.checkColliCount) {
                this.$emit('finish-check-colli');
            } else {
                this.timer.finished = true;
                this.$emit('finish');
            }
        },
        onErrorReporting() {
            this.timer.paused = true;
            this.$emit('reporting-error');
        },
    },
    computed: {
        remainingSeconds() {
            const now = parseInt(Date.now() / 1000, 10);
            const elapsed = now - this.originalTimeStamp;

            //To make the timer have effect, include dummy in the computed
            let seconds = this.dummy;
            seconds += this.dummy;

            return this.originalSeconds - elapsed;
        },
        color() {
            const colors = this.colors;

            if (this.remainingSeconds <= 0) {
                return colors.red;
            }

            const share = this.remainingSeconds / this.originalTime;

            if (share <= 0.1) {
                return colors.orange;
            }

            return colors.green;
        },
        containerStyle() {
            return { backgroundColor: this.color.backColor };
        },
        textStyle() {
            return { color: this.color.frontColor };
        },
    },
};
</script>
